export const 
ROUTE_PATHS = {
    GAMIFICATION: '/edit-preference/gamification',
    BUY_POINTS: '/edit-preference/gamification/buy-points',
    BADGES: '/edit-preference/gamification/badges',
    EDIT_WELCOME_MESSAGE: '/edit-preference/edit-welcome-message',
    EXPLORE_CREATORS: '/explore-creators',
    AUTH: 'auth',
    DASHBOARD: 'dashboard',
    HOME_PATH: '/',
    CONTENT_PATH: '/content',
    DASHBOARD_PATH: '/dashboard',
    EDIT_PREFERENCE_PATH: '/edit-preference',
    FORUM: 'forum',
    MONETIZE: 'monetize',
    EDIT_PREFERENCE: 'edit-preference',
    EDIT_PREFERENCE_WHITELABEL: '/edit-preference/whitelabel',
    OPT_OUT: 'opt-out',
    CONTENT: 'content',
    POST: 'post',
    WALLET: 'wallet',
    ORDER_STATUS: 'order-status',
    MESSAGES: 'messages',
    INSIGHTS: 'insights',
    PRIVACY_POLICY: 'privacy-policy',
    TERMS_CONDITIONS: 'terms-conditions',
    CONTACT_US: 'contact-us',
    REQUEST_DEMO: 'request-demo',
    SCHEDULE_A_DEMO: 'schedule-a-demo',
    UNSUBSCRIBE_INSTRUCTION: 'unsubscribe-instruction',
    ABOUT: 'about',
    PRICING: 'pricing',
    ADVERTISE: 'advertise',
    GLOBAL: 'global',
    TERMS_OF_SERVICE: 'terms-of-service',
    TOPFANS_VS_PASSES: 'topfan-vs-passes',
    TOPFANS_VS_FANFIX: 'topfan-vs-fanfix',
    HELP_FAQ: 'help-faq',
    SHARE: 'share/:shortend-url',
    ACCESS_USER: 'access-user',
    RESOURCES: 'resources',
    CREATORS: 'creators',
    NOT_FOUND: 'not-found',
    PROFILE: ':id',
    HOME: '',
    WILDCARD: '**',
    CREATOR: 'creator',
    EXPLORE_CREATORS_ROUTE: 'explore-creators',
    NEWSLETTER_UNSUBSCRIBE: 'unsubscribe/newsletter',
    IMPORTED_OPT_OUT: 'imported/opt-out',
    NEWSLETTER_PURCHASES: '/wallet/my-purchases/newsletter',
    ADVERTISEMENT_HOME: 'advertisement',
    SHOPIFY_CONNECT: 'shopify-connect',
    CALENDAR_CONNECT: 'calendar-connect',
    LIVE_STREAM: '/dashboard/live-stream',
    INSIGHTS_PATH: '/insights',
    ADVERTISE_WITH_US: '/advertise',
    AUTH_LOGIN: '/auth/login',
    AUTH_SIGNUP: '/auth/signup',
    AUTH_VERIFY_BY_OTP: '/auth/verify-by-otp',
    PRESS_ROOM: 'https://www.topfan.com/explore/press-room',
    BIO: 'bio',
    EDIT_PREFERENCE_LIB: '/edit-preference/link-in-bio',
    ADD_LINK_IN_BIO: '/add-link-in-bio',
    INSIGHTS_DETAIL_VIEW: '/insights/detail-view',
    RESEARCH: 'https://www.topfan.com/explore/research',
    TOPFANS_PRO: 'https://www.topfan.com/pro',
    TOPIC_TAGS: '/edit-preference/topic-tags',
    OUTBOUND_EMAILS: '/edit-preference/outbound-emails',
    EARN_POINTS: '/edit-preference/gamification/earn-points',
    GROUPS: '/edit-preference/groups',
};

export const KNOWN_TOP_LEVEL_ROUTES = [
  'creators', 'creator', 'auth', 'dashboard', 'advertise', 'content', 'forum',
  'monetize', 'edit-preference', 'opt-out', 'post', 'wallet', 'order-status',
  'messages', 'insights', 'privacy-policy', 'terms-conditions', 'contact-us',
  'request-demo', 'schedule-a-demo', 'unsubscribe-instruction', 'about', 'pricing', 'global',
  'terms-of-service', 'help-faq', 'access-user', 'resources', 'not-found',
  'explore-creators', 'advertisement', 'shopify-connect', 'calendar-connect'
] as const;
  